<template>
  <div class="unbundele-dialog">
    <!-- 解绑提示弹窗 -->
    <mk-dialog
      v-if="visible"
      :visible="visible"
      title="解绑公众号"
      width="30%"
      @close="dialogCancel"
    >
      <!-- 解绑公众号提示内容 -->
      <div
        v-if="dialogStatus===1"
        class="hint-content"
      >
        <p
          v-for="(item,index) in hintInfoList"
          :key="index"
          class="hintInfo"
        >
          {{ item }}
        </p>
      </div>
      <!-- 公众号粉丝处理 -->
      <div
        v-else-if="dialogStatus===2"
        class="fans-dispose"
      >
        <p class="fans-dispose-text">
          您的公众号粉丝同步为线索的{{ syncPeople }} 人， 其中有互动行为的{{ interaction }}人，解绑后您可能再无法对这些线索进行触达，请先进行处理。
        </p>
        <mk-radio
          v-model="fansRadio"
          label="1"
        >
          移除全部来源于公众号的线索
        </mk-radio>
        <mk-radio
          v-model="fansRadio"
          label="2"
        >
          移除来源于公众号无互动行为的线索
        </mk-radio>
      </div>
      <!-- 解绑发送验证码 -->
      <div
        v-else-if="dialogStatus===3"
        class="send-code"
      >
        <p class="send-code-text">
          解绑后将导致原有小程序不可访问，请谨慎操作：
        </p>
        <!-- 验证码表单 -->
        <mk-form
          ref="params"
          class="code-form"
          :model="codeForm"
        >
          <mk-form-item
            label="登录账号："
            prop="phone"
          >
            {{ codeForm.phoneNumber }}
          </mk-form-item>
          <mk-form-item
            label="验证码："
            prop="code"
          >
            <mk-input
              v-model="codeForm.code"
              height="30"
              width="180"
              placeholder="请输入验证码"
            >
            </mk-input>
            <mk-button-biz
              type="primary"
              class="sent-btn"
              :disabled="!showSent"
              @click="getCode"
            >
              <span v-if="showSent">发送验证码</span>
              <span
                v-else
                class="count"
              >{{ count }}s重新发送</span>
            </mk-button-biz>
            <p
              class="wrong-code"
            >
              {{ codeMsg }}
            </p>
          </mk-form-item>
        </mk-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <mk-button-biz @click="dialogCancel">取 消</mk-button-biz>
        <mk-button-biz
          type="primary"
          @click="dialogConfirm"
        >确 定</mk-button-biz>
      </span>
    </mk-dialog>
  </div>
</template>
<script>
export default {
  name: 'UnbundeleDialog',
  components: {},
  mixins: [],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    authorizerAppId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 弹窗当前内容
      dialogStatus: 1,
      // 是否开启公众号粉丝同步线索
      isFans: false,
      // 粉丝同步为线索的人数
      syncPeople: 1899,
      // 粉丝中互动行为人数
      interaction: 1234,
      // 验证错误提示
      isRightCode: '',
      // 粉丝处理单选
      fansRadio: '1',
      codeForm: {
        phoneNumber: '',
        code: ''
      },
      // 解绑提示信息
      hintInfoList: [
        '解绑公众号后将导致以下情况，请谨慎操作：',
        '1、获客文章、H5、表单等功能不可用',
        '2、公众号管理相关设置清空',
        '3、管理公众号文章文章同步功能不可用',
        '4、来源为公众号的线索无法触达'
      ],
      // 倒计时
      showSent: true,
      count: '', // 初始化次数
      timer: null,
      timeCount: 60,
      codeMsg: ''

    }
  },
  watch: {
    visible (cur, old) {
      let that = this
      if (cur !== old && !cur) {
        that.dialogStatus = 1
      }
    }
  },
  mounted () {
    this.getPhoneNumber()
  },
  methods: {
    // 获取管理员绑定手机号
    async getPhoneNumber () {
      let res = await BIZAPIS.ManageApi.authManagePhoneGet()
      if (res.success) {
        this.codeForm.phoneNumber = res.data
      }
    },
    // 弹框信息确认操作
    dialogConfirm () {
      if (this.dialogStatus === 1) {
        // 是否开启公众号粉丝同步线索的功能
        if (this.isFans === true) {
          // 开启，进入公众号粉丝处理提醒
          this.dialogStatus = 2
        } else {
          // 未开启，直接进入发送验证码流程
          this.dialogStatus = 3
        }
      } else if (this.dialogStatus === 2) {
        // 公众号粉丝处理提醒
        this.dialogStatus = 3
      } else if (this.dialogStatus === 3) {
        // 发送验证码流程
        // 校验验证码
        this.unbundele()
        this.fansRadio = '1'
      }
    },
    // 关闭弹框
    dialogCancel () {
      this.$emit('update:visible', false)
      this.$emit('on-close')
      this.initCode()
      this.codeForm.code = ''
      this.codeMsg = ''
    },
    // 验证码倒计时初始化
    initCode () {
      this.showSent = true
      clearInterval(this.timer) // 清除定时器
      this.timer = null
      this.count = ''
    },
    // 获取验证码
    getCode () {
      if (!this.timer) {
        this.count = this.timeCount
        this.showSent = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= this.timeCount) {
            this.count--
          } else {
            this.initCode()
          }
        }, 1000)
      }
      this.getCodeApi()
    },
    // 请求短信验证码接口
    async getCodeApi () {
      let params = {
        phone: this.codeForm.phoneNumber,
        expire: 1,
        length: 6,
        type: 1
      }
      let res = await BIZAPIS.SmsApi.smsWeixinAuthSendSmsCodePost(params)
    },
    // 解绑接口（含验证码校验
    async unbundele () {
      let params = {
        code: this.codeForm.code,
        phone: this.codeForm.phoneNumber,
        appId: this.authorizerAppId
      }
      let res = await BIZAPIS.ManageApi.authManageWeixinAccountDelete(params)
      if (res.success) {
        this.$message.success('解绑成功')
        // 成功后关闭弹窗，重载页面
        location.reload()
      } else if (res.data === false) {
        this.codeMsg = res.msg
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.unbundele-dialog {
  // 解绑公众号提示内容
  .hint-content {
    .hintInfo {
      font-size: 16px;
      padding-bottom: 16px;
    }
  }
  // 公众号粉丝处理
  .fans-dispose {
    .fans-dispose-text {
      font-size: 16px;
      line-height: 28px;
    }

    /deep/ .el-radio {
      padding: 10px 0;
    }
  }
  // 解绑发送验证码
  .send-code {
    .send-code-text {
      font-size: 16px;
      padding-bottom: 30px;
    }

    /deep/ .el-form-item {
      margin-bottom: 5px;
    }

    /deep/ .el-form-item__label {
      width: 90px;
    }

    .sent-btn {
      margin-left: 30px;
    }

    .wrong-code {
      color: red;
      padding-left: 90px;
    }
  }
}
</style>
